import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioSignalsmithBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioSignalsmithBox({
            uuid,
            graph,
            name: "AudioSignalsmithBox",
            pointerRules: {
                accepts: [Pointers.AudioPlayMode],
                mandatory: true,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "AudioSignalsmithBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioSignalsmithBox, this);
    }
    get tags() {
        return AudioSignalsmithBox.Tags;
    }
    get warpMarkers() {
        return this.getField(1);
    }
    get transpose() {
        return this.getField(2);
    }
    initializeFields() {
        return {
            1: Field.hook({
                parent: this,
                fieldKey: 1,
                fieldName: "warpMarkers",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.WarpMarkers],
                    mandatory: true,
                    exclusive: false,
                },
            }),
            2: Float32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "transpose",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: -24, max: 24, scaling: "linear" }, "st", 0),
        };
    }
}
